<template>
	<div class="events">
		<div class="events__search">
			<h2>SEARCH EVENTS</h2>
			<div class="events__search__row">
				<div class="events__search__col">
					<div class="events__search__input">
						<input type="text" name="keyword" placeholder="Keyword Search" v-model="keywords">
						<button @click="searchKeywords = true" class="search-submit search-icon"></button>
					</div>
					<p>Filter By Date</p>
					<div class="events__search__input">
						<div class="events__search__input--row">
							<v-date-picker
						      v-model="dateFrom"
							  v-if="openDateFrom == true"
							  full-width
						    >
							<v-btn flat color="primary" @click="openDateFrom = false">OK</v-btn>
							</v-date-picker>
							<span v-if="!dateFrom">From</span> <span v-if="dateFrom">{{ date(dateFrom)}}</span>
						</div>
						<!-- <input type="date" name="dateFrom" value="" placeholder="From" v-model="dateFrom"> -->
						<button @click="openDateFrom = !openDateFrom; openDateTo = false;" class="calendar-icon"></button>
					</div>
					<div class="events__search__input">
						<div class="events__search__input--row">
							<v-date-picker
							  v-model="dateTo"
							  v-if="openDateTo == true"
							  full-width
							>
							<v-btn flat color="primary" @click="openDateTo = false">OK</v-btn>
							</v-date-picker>

							<span v-if="!dateTo">To</span> <span v-if="dateTo">{{ date(dateTo)}}</span>
						</div>
						<button @click="openDateTo = !openDateTo; openDateFrom = false;" class="calendar-icon"></button>
					</div>

				</div>
				<div class="events__search__col">
					<div class="events__search__input">
						<ul name="category" id="category">
							<li @click="openCat = !openCat"><label for="">Filter by Category</label></li>
							<li v-for="(cat, index) in categories" :key="cat" v-if="openCat" v-model="categories">
								<input :id="index" type="checkbox" :value="index" v-model="checkedCategory" :class="{ active: checkedCategory.includes(index) }">
								<label :for="index">{{cat}}</label>
							</li>
						</ul>

					</div>
					<div class="events__search__input">
						<ul name="location" id="location">
							<li @click="openLocation = !openLocation"><label for="">Filter By Location</label></li>
							<li v-if="openLocation == true" v-for="(location, index) in locations" :key="location">

									<input :id="index" type="checkbox" :value="index" v-model="checkedLocation" :class="{ active: checkedLocation.includes(location) }">
								<label :for="index">{{location}}</label>
							</li>
						</ul>

					</div>
					<!-- <div class="events__search__input">
						<button class="events__search__submit">Apply Selection</button>
					</div> -->
				</div>
			</div>
		</div>
		<h2>UPCOMING EVENTS</h2>
		<div class="events__container">
			<div class="events__container__tile" :key="index" v-for="(event, index) in filteredEvents" v-if="index < perPage">
				<img :src="event.multimedia[0].serverPath" alt="">
				<div class="events__container__content">
					<h3>{{event.productName}}</h3>
					<p class="events__container__date">{{date(event.nextOccurrence)}}<span v-if="event.nextOccurrence !== event.frequencyEndDate"> - {{date(event.frequencyEndDate)}}</span></p>
					<p class="events__container__description">
						{{substr(event.productDescription)}}
					</p>
					<router-link
					class="events__container__button"
					:to="{
						name: 'single',
						params: {
							url: decodeURI(formatLink(event.productName)),
							id: event.productId,
							event: event,
							checkedCategory: checkedCategory,
							checkedLocation: checkedLocation,
							keywords: keywords,
							dateTo: dateTo,
							dateFrom: dateFrom
						}
					}
					">Read More</router-link>
				</div>
			</div>
		</div>
		<div class="events__load-more">
			<hr>
			<button @click="loadMore()" type="button" name="button" class="load-more">Load More Events</button>
			<hr>
		</div>
	</div>
</template>

<script type="text/javascript">
import axios from 'axios'
import moment from 'moment'
export default {
	name: 'events-listing',
	props: ['event'],
	data() {
		return {
			events: [],
			categories: {},
			perPage: 12,
			keywords: '',
			dateFrom: '',
			dateTo: '',
			openDateFrom: false,
			openDateTo: false,
			searchKeywords: false,
			locations: {},
			openCat: false,
			openLocation: false,
			checkedCategory: [],
			checkedLocation: []
		}
	},
	computed: {
		filteredEvents() {
			let events = this.events
			if(this.searchKeywords == true) {
				events = this.filteredKeywords()
			}
			if(this.checkedCategory && this.checkedCategory.length > 0) {
				events = this.filteredCategory()
			}
			if(this.checkedLocation && this.checkedLocation.length > 0) {
				events = this.filteredLocations()
			}
			if(this.dateTo && this.dateTo.length > 0) {
				events = this.filteredDate()
			}
			events = events.sort(function(a, b) {
				if(a !== null && b !== null) {
					return new Date(a.nextOccurrence) - new Date(b.nextOccurrence)
				}
			})
			this.searchKeywords = false
			return events
		}
	},
	methods: {
		getEvents() {
			let _this = this
			axios.get('https://events.dssn.com.au/src/data.json')
			.then(function(response) {
				response.data.map((v) => {
					if(!_this.categories.hasOwnProperty(v.verticalClassifications[0].productTypeId)) {
						_this.categories[v.verticalClassifications[0].productTypeId] = v.verticalClassifications[0].productTypeDescription
					}
					if(!_this.locations.hasOwnProperty(v.lga)) {
						if(typeof v.lga !== undefined && v.lga !== undefined) {
						   _this.locations[v.lga] = v.lga
				   		}
					}
				})
				_this.events = response.data
			})
			.catch(function(error) {

			})
		},
		// getEvents() {
		// 	let _this = this
		// 	let endpoint = 'https://atlas.atdw-online.com.au/api/atlas/products?key=baeec540167b4d0288efa39496d05e2c&cats=EVENT&rg=Blue%20Mountains,Hunter,Central%20Coast,Greater%20Sydney&size=100&out=json'
		// 	axios.get(endpoint)
		// 	.then(function(response) {
		// 		let count = 0
		// 		response.data.products.map( (product) => {
		// 			let productEndpoint = 'https://atlas.atdw-online.com.au/api/atlas/product?productId='+product.productId+'&key=baeec540167b4d0288efa39496d05e2c&out=json'
		// 			axios.get(productEndpoint)
		// 				.then( (res) => {
		//
		// 					_this.events.push(res.data)
		//
		// 					//uniquealize keys
		// 					if(!_this.categories.hasOwnProperty(res.data.verticalClassifications[0].productTypeId)) {
		// 						_this.categories[res.data.verticalClassifications[0].productTypeId] = res.data.verticalClassifications[0].productTypeDescription
		// 					}
		//
		// 					if(!_this.locations.hasOwnProperty(res.data.cityName)) {
		// 					   _this.locations[res.data.cityName] = res.data.cityName
		// 				   }
		//
		// 					count++
		// 				})
		// 				.catch(function(error) {
		// 					console.log(error)
		// 				})
		// 		})
		// 	})
		// 	.catch(function(error) {
		// 		console.log(error)
		// 	})
		// },
		saveFile(key, value) {
	        return localStorage.setItem(key, JSON.stringify(value))
		},
		getFile(key) {
			let val = localStorage.getItem(key)
			if(val !== '' && val !== undefined) {
				return val
			}
			return val
		},
		date(date) {
			return moment(date).format('D MMM YYYY')
	 	 },
		formatLink(link) {
			return link.replace(/\s+/g, '-').toLowerCase()
		},
		substr(str) {
			return str.substring(0, 75)+'...'
		},
		loadMore(perPage) {
			return this.perPage += 12
		},
		filteredKeywords() {
			let events = this.events
			let keywords = this.keywords
			let keywordsArray = keywords.split(" ").filter((value) => value)

			//start filtering Match Product Name and Description
			events = events.filter( (value) => {
				return keywordsArray.some((keyword) =>
					value.productName.toLowerCase().includes(keyword.toLowerCase())
				)
			})
			return events
		},
		filteredCategory() {
			let events = this.events
			let categoryArray = this.checkedCategory
			events = events.filter( (value) => {
				return categoryArray.some((category) =>
					value.verticalClassifications[0].productTypeId.includes(category)
				)
			})
			return events
		},
		filteredLocations() {
			let events = this.events
			let locationArray = this.checkedLocation
			events = events.filter( (value) => {
				return locationArray.some((location) =>
					value.lga !== null && value.lga !== undefined ? value.lga.includes(location) : ''
				)
			})
			return events
		},
		filteredDate() {
			let events = this.events
			let dateFrom = this.dateFrom
			let dateTo = this.dateTo
			events = events.filter( (value) => {
				return value !== null ? (value.frequencyEndDate <= dateTo && value.frequencyStartDate  >= dateFrom) : ''
			})
			return events
		},
		idleTimer() {
		    let t;
			let _this = this
		    window.onmousemove = function() {
			   clearTimeout(t);
			   t = setTimeout(function() {
				   _this.openCat = false
				   _this.openLocation = false
				   _this.openDateFrom = false
				   _this.openDateTo = false
			   }, 6000)
			}
		    window.onclick = function() {
			   clearTimeout(t);
			   t = setTimeout(function() {
				   _this.openCat = false
				   _this.openLocation = false
				   _this.openDateFrom = false
				   _this.openDateTo = false
			   }, 6000)
			}
		    window.onscroll = function() {
			   clearTimeout(t);
			   t = setTimeout(function() {
				   _this.openCat = false
				   _this.openLocation = false
				   _this.openDateFrom = false
				   _this.openDateTo = false
			   }, 6000)
			}
		}
	},
	created() {
		this.getEvents()
		this.idleTimer()
	},
	mounted() {
		//save data from child
		if(this.$route.params.checkedCategory !== undefined) {
			this.checkedCategory = this.$route.params.checkedCategory
		}
		if(this.$route.params.checkedLocation !== undefined) {
			this.checkedLocation = this.$route.params.checkedLocation
		}
		if(this.$route.params.keywords !== undefined) {
			this.keywords = this.$route.params.keywords
		}
		if(this.$route.params.dateFrom !== undefined) {
			this.dateFrom = this.$route.params.dateFrom
		}
		if(this.$route.params.dateTo !== undefined) {
			this.dateTo = this.$route.params.dateTo
		}
	}
}
</script>

<style media="screen" lang="scss">
	.events {
		background-color: #ffffff;
		z-index: 10;
		position: relative;
		max-width: 1140px;
		margin: 3em auto;
		font-weight: 100;
		padding: 0 1.50rem;
		h2 {
			margin-bottom: 30px;
		}
		h3 {
			margin: 1rem 0;
		}
		&__search {
			font-weight: 100;
			font-family: 'Merlo Regular', Helvetica, sans-serif;
			&__row {
				display: flex;
				flex-flow: row wrap;
				justify-content: space-between;
				margin-bottom: 30px;
			}
			&__col {
				width: 48%;
				@media all and (max-width: 768px) {
					width: 100%;
				}
				&:last-child {
					.events__search__input {
						display: flex;
						flex-flow: column;
					}
				}
			}
			&__input {
				display: flex;
				margin-bottom: 20px;
				input, select, &--row {
					width: 90%;
					padding: 0 10px;
					box-sizing : border-box;
					height: 50px;
					appearance: none;
					-webkit-appearance: none;
					-moz-appearance: none;
					border: 1.22px solid #C0D1E3;
					color: #4A79AC;
					font-size: 16px;
					border-radius: 0;
					outline: none;
					background-color: #ffffff;
					font-weight: 100;
					display: flex;
					align-items: center;
					position: relative;
					.v-picker {
						position: absolute;
						top: 0;
						z-index: 1000;
						background: white;
						left: 0;
						width: 100%;
						span {
							display: none;
						}
					}
					&::placeholder {
						color: #4A79AC;
						font-size: 16px;
						border-radius: 0;
					}
				}
				select {
					@media all and (max-width: 768px) {
						width: 100%;
					}
				}
				input[type="date"]:before {
				   content: attr(placeholder) !important;
				   margin-right: 0.5em;
				   color: #4A79AC;
				   font-family: 'Merlo Regular', Helvetica, sans-serif;
				   font-weight: 100;
				 }
				 input[type="date"]:focus:before,
				 input[type="date"]:valid:before {
				   content: "";
				 }
			}
			&__submit {
				border: 1.22px solid #C0D1E3 !important;
				padding: 15px 50px;
				color: #4A79AC;
				margin: auto;
				font-size: 16px;
				font-weight: 100;
				background-color: #ffffff !important;
			}
		}
		&__container {
			display: flex;
			flex-flow: row wrap;
			justify-content: space-between;
			align-items: flex-start;
			&__tile {
				width: 32%;
				border: 1px solid #C0D1E3;
				background-color: #FFFFFF;
				margin-bottom: 30px;
				img {
					width: 100%;
					height: 260px;
					object-fit: cover;
				}
				@media all and (max-width: 1140px) {
					width: 48%;
				}
				@media all and (max-width: 768px) {
					width: 100%;
				}
			}
			&__content {
				padding: 0 20px 20px 20px;
				height: 200px;
				position: relative;
				h3 {
					font-size: 16px;
					font-weight: 100;
					letter-spacing: 0.5px;
					line-height: 22px;
					color: #4A79AC;
				}
			}
			&__description {
				font-size: 14px !important;
				font-weight: 100;
				letter-spacing: 0.47px;
				line-height: 21px;
			}
			&__button {
				border: 1px solid #C0D1E3;
				background-color: #FFFFFF;
				text-decoration: none;
				color: #4A79AC;
				padding: 10px 20px 10px 20px;
				display: flex;
				justify-content: center;
				align-items: center;
				font-size: 14.08px;
				bottom: 20px;
				position: absolute;
				&::after {
					content: url('/img/arrowicon.svg');
					display: inline-block;
					margin-left: 20px;
					height: 15px;
					width: 15px;
				}
				&:hover {
					background-color: #4A79AC;
					color: #ffffff;
					&::after {
						content: url('/img/arrowicon-white.svg');
					}
				}
			}
			&__date {
				font-size: 16px;
				font-weight: 100;
				letter-spacing: 0.5px;
				line-height: 22px;
				color: #000000;
			}
		}
		&__load-more {
			text-align: center;
			display: flex;
			justify-content: space-between;
			margin-top: 50px;
			align-items: center;
			hr {
				width: 45%;
				height: 1px;
				border: none;
				background-color: #979797;
			}
			button {
				color: #979797;
				font-family: 'Merlo Regular', sans-serif;
				font-size: 16px;
				font-weight: 100;
				letter-spacing: 0.5px;
				line-height: 19px;
				border: none;
				background: transparent;
				width: 200px;
				outline: none;
			}
		}
	}
	.search-icon, .calendar-icon {
		background-image: url('/img/searchicon.svg');
		background-color: #4A79AC;
		background-repeat: no-repeat;
		height: 50px;
		width: 50px;
		padding: 0;
		border: 1px solid #4A79AC;
		margin-left: 10px;
	}
	.calendar-icon {
		background-image: url('/img/calendaricon.svg');
	}
	#category, #location {
		margin-top: 0;
		width: 100%;
		background-image: url('/img/down-arrow.svg');
		background-repeat: no-repeat;
		// background-position: center right 20px;
		padding-left: 0;
		li {
			list-style: none;
			display: flex;
			justify-content: flex-start;
			align-items: center;
			border: solid 1px #CFDCEA;
			padding-left: 20px;
			cursor: pointer;
			&:first-child {
				padding: 0 10px;
				box-sizing : border-box;
				height: 50px;
				appearance: none;
				-webkit-appearance: none;
				-moz-appearance: none;
				border: 1.22px solid #C0D1E3;
				color: #4A79AC;
				font-size: 16px;
				border-radius: 0;
				outline: none;
				background-color: #ffffff;
				font-weight: 100;
				background-image: url('/img/down-arrow.svg');
				background-repeat: no-repeat;
				background-position: center right 20px;
			}
			label {
				display: flex;
				justify-content: flex-start;
				align-items: center;
				cursor: pointer;
				padding: 20px 20px 20px 0;
				width: 100%;
			}
		}
		input[type="checkbox"] {
			width: 20px;
			height: 20px;
			border-radius: 50%;
			border: solid 1px #4A79AC;
			margin-right: 20px;
		}
	}
	.active {
		background-color: #4A79AC !important;
	}
</style>
